import React, { useEffect, useState } from 'react';
import { supportAPI } from '../../lib/api';
import { RecalculationAPI, RecalculationPanel } from './RecalculationPanel';

export const supportRecalculationKey = (user: string, appealId?: string) =>
    `support-recalculation:${user}:${appealId ? `appeal:${appealId}` : 'dashboard'}`;

export const SupportRecalculationPanel: React.FC<{
    user: string; transactionId?: string; appealId?: string; onCompleted: () => void;
}> = ({ user, transactionId, appealId, onCompleted }) => {
    const client: RecalculationAPI = appealId ? {
        getRecalculation: () => supportAPI.getAppealRecalculation(appealId),
        previewRecalculation: (_, payload) => supportAPI.previewAppealRecalculation(appealId, payload),
        createRecalculation: (_, payload) => supportAPI.createAppealRecalculation(appealId, payload),
        getRecalculationOperation: supportAPI.getRecalculationOperation,
    } : supportAPI;
    return <RecalculationPanel apiClient={client} storageKey={supportRecalculationKey(user, appealId)}
        initialTransactionId={transactionId} appealMode={!!appealId} showManualCallback={!appealId} callbackApiClient={supportAPI}
        callbackStorageScope={`support:${user}`} onCompleted={onCompleted} />;
};

// Keep recovery reachable after navigation, closing a modal, or reloading the page.
export const SupportPendingRecalculations: React.FC<{
    user: string; excludedKeys: string[]; onCompleted: () => void;
}> = ({ user, excludedKeys, onCompleted }) => {
    const [revision, setRevision] = useState(0);
    useEffect(() => {
        const refresh = () => setRevision(v => v + 1);
        window.addEventListener('recalculation-pending-changed', refresh);
        window.addEventListener('storage', refresh);
        return () => {
            window.removeEventListener('recalculation-pending-changed', refresh);
            window.removeEventListener('storage', refresh);
        };
    }, []);
    const pending: { key: string; appealId?: string; transactionId: string }[] = [];
    try {
        for (const key of Object.keys(localStorage)) {
            if (!key.startsWith(`support-recalculation:${user}:`) || excludedKeys.includes(key)) continue;
            const value = JSON.parse(localStorage.getItem(key) || 'null');
            if (value?.transactionId && value?.request?.request_id) pending.push({ key, transactionId: value.transactionId,
                appealId: key.includes(':appeal:') ? key.split(':appeal:')[1] : undefined });
        }
    } catch { /* Storage can be unavailable in private browsing. */ }
    return <div data-revision={revision}>{pending.map(item => <div key={item.key} className="my-4">
        <p className="font-semibold">Проверка незавершённого перерасчёта</p>
        <SupportRecalculationPanel user={user} transactionId={item.transactionId} appealId={item.appealId} onCompleted={onCompleted} />
    </div>)}</div>;
};
